import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { Hero, BecomeMember } from '../components/Sections'
import { getAssetUrl } from '../services/cdn'
import { Container, Row, Col } from 'reactstrap'
import { Container as BlockContainer, FeaturedMC, FloatingCTA } from '../components/Blocks'
import LoanCalculator from '../components/Forms/LoanCalculator'


const IndexPage = () => (
  <Layout>
    <SEO title="Home" keywords={[`gatsby`, `application`, `react`]} />
    <Hero src='koopsiklo/Koopsiklo-homeBanner.jpg' mobileSrc='koopsiklo/Koopsiklo-homeBanner.jpg' fullMobile height={600} x={10} y={100} />
    <BlockContainer>
      <Container>
        <Row>
          <Col md="12">
              <h1 className="mb-3">KoopSiklo – Your Partner on the Road to Mobility and Convenience</h1>
              <div className="text-justify">
                <p>KoopSiklo is the official motorcycle dealership of Sorosoro Ibaba Development Cooperative (SIDC), created to provide accessible, affordable, and reliable motorcycle units for our valued members. Whether you're looking for a new ride for personal use, business needs, or delivery services, KoopSiklo has the perfect option for you.</p>
                <p>As a member of SIDC, you can take advantage of our flexible payment schemes—choose to purchase your motorcycle in cash or through our convenient loan program with friendly terms. KoopSiklo carries a variety of trusted brands and models to fit your lifestyle and budget.</p>
                <p>At KoopSiklo, we don’t just sell motorcycles we help power your goals. With easy application processes, after sales support, and the backing of a strong cooperative, we’re with you every step of the way.</p>
              </div>
          </Col>
        </Row>
      </Container>
    </BlockContainer>
     <BlockContainer style={{background: "#80C341"}}>
      <Container>
        <Row>
          <Col md="12">
              <h1 className="mb-3">Your Adventure Begins Today.</h1>
              <p>From competitive pricing and easy, flexible loan options, to our exclusive rider programs and 100% original parts and accessories, KoopSiklo is committed to giving you a complete and reliable riding experience—designed especially for our Ka-SIDC.</p>
             <Col lg-12>
               <div>
                <h6 style={{textAlign: "left"}}> <b> 👨‍🔧🔧HIGHLY TRAINED STAFF</b></h6>
               </div>
               <div className="text-justify">
                <p>Each KoopSiklo branch is staffed with well-trained, supplier-certified personnel, including qualified mechanics. More than that, our team is approachable, professional, and ready to serve you with a smile.</p>
              </div>
             </Col>
             <Col lg-12>
               <div>
                <h6 style={{textAlign: "left"}}> <b> 🕒 FAST & HASSLE-FREE SERVICE</b></h6>
               </div>
               <div className="text-justify">
                <p>Enjoy the fast loan approval with minimal requirements. Our friendly and efficient customer service team is here to assist you every step of the way—from application to delivery.</p>
              </div>
             </Col>
             <Col lg-12>
               <div>
                <h6 style={{textAlign: "left"}}> <b> 💳 FLEXIBLE PAYMENT OPTIONS</b></h6>
               </div>
               <div className="text-justify">
                <p>Choose between cash purchase or a loan program with member-friendly terms and easy processing</p>
              </div>
             </Col>
             <Col lg-12>
               <div>
                <h6 style={{textAlign: "left"}}> <b> 🛵 Wide Selection of Trusted Brands </b></h6>
               </div>
               <div className="text-justify">
                <p>Find the motorcycle that fits your lifestyle and needs from a range of quality brands and models</p>
              </div>
             </Col>
             <Col lg-12>
               <div>
                <h6 style={{textAlign: "left"}}> <b> 🎁 ELIIGIBLE FOR PATRONAGE REFUND</b></h6>
               </div>
               <div className="text-justify">
                <p>Your motorcycle purchase is added to your total SIDC purchases, making you eligible for an annual patronage refund.</p>
              </div>
             </Col>
          </Col>
        </Row>
      </Container>
    </BlockContainer>
    <FeaturedMC />
    <BlockContainer>
      <Hero className="get-banner" src='koopsiklo/get-banner.jpg' mobileSrc='koopsiklo/get-banner.jpg' fullMobile height={350} x={10} y={100} />
      <div className="branches-map" style={{display: "flex", height: "350px", width: "100%" }}>
        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", padding: "20px", width: "50%" }}>
          <img src={getAssetUrl("koopsiklo/get-yours.jpg")} style={{width: "250px", marginLeft: "70px"}}></img>
        </div>
        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", padding: "20px", width: "50%" }}>
          <div className="loan-wrapper" style={{ marginBottom: "20px" }}>
            <h3 style={{fontWeight: 400}}>MOTORCYLE LOAN CALCULATOR</h3>
            <p><b>Find the Motorcycle That Fits You—and Your Budget!</b> Customize your preferred payment terms and explore estimated monthly installments using our <b>loan calculator.</b> Once you're ready, <b>apply for a loan in just a few clicks</b> and start your journey with KoopSiklo today!</p>
             <div className="checkloan-btn">
                <a href="#loan-calc">CHECK LOAN CALCULATOR</a>
            </div>
          </div>
        </div>
    </div>
    </BlockContainer>
    <LoanCalculator id={"loan-calc"}/>
  </Layout>
)

export default IndexPage
